module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo20-fe820b579eacfbc9216834d72c6df033.jpg";